import { getObjectKeysAsObject } from "@hopper-b2b/checkout";
import { createGoogleIdentitySessionService } from "./createGoogleIdentitySession";
import { finalizeUserService } from "./finalizeUser";
import { resendCodeService } from "./resendCode";
import { sendCodeForMergeService } from "./sendCodeForMerge";
import { sendCodeToEmailService } from "./sendCodeToEmail";
import { sendCodeToPhoneService } from "./sendCodeToPhone";
import { verifyCodeService } from "./verifyCode";
import { verifyMergeUserService } from "./verifyMergeUser";

export const AuthServices = {
  createGoogleIdentitySessionService,
  finalizeUserService,
  resendCodeService,
  sendCodeForMergeService,
  sendCodeToEmailService,
  sendCodeToPhoneService,
  verifyCodeService,
  verifyMergeUserService,
};

export const AuthServiceTypes = getObjectKeysAsObject(AuthServices);
